import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/version/index.js
// module id = 846
// module chunks = 0